(function () {
	'use strict';

	angular.module('jcsfApp').controller('rsasController', rsasController);

	rsasController.$inject = ['$controller', '$scope', 'events', 'authService'];

	function rsasController($controller, $scope, events, authService) {
		$controller('baseController', { $scope: $scope });

		var vm = this;
		vm.rsas = [];
		vm.orderBy = sessionStorage.getItem('rsasOrderBy') || 'Region';
		vm.orderByReverse = false;
		vm.setOrderBy = setOrderBy;
		vm.remove = deleteComponent;

		authService.fillAuthData();
		activate();

		function activate() {
			if (
				authService.authentication.userName == null ||
				!authService.authentication.isAuth ||
				!authService.authentication.userInfo.Roles.includes('Administrator')
			) {
				$scope.$state.go('home');
			}

			$scope.subscribe(
				events.message._GET_RSA_LIST_COMPLETE_,
				function (results) {
					vm.rsas = results;
				}
			);

			$scope.publish(events.message._GET_RSA_LIST_, []);
		}

		function deleteComponent(part) {
			var confirmed = window.confirm(
				'Are you sure you want to delete ' + part.RSA + '?'
			);

			if (confirmed) {
				$scope.publish(events.message._DELETE_RSA_, [part.RSAId]);
			}
		}

		/**
		 * @param {string} column
		 */
		function setOrderBy(column) {
			vm.orderByReverse = vm.orderBy === column ? !vm.orderByReverse : false;
			vm.orderBy = column;
			sessionStorage.setItem('rsasOrderBy', column);
		}
	}
})();
